import { Location } from "@angular/common";
import { HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import {
    ActivatedRouteSnapshot,
    Resolve,
    RouterStateSnapshot,
} from "@angular/router";
import { ApiGateway, PageOptions, Speciality } from "cw-backend";
import { CwUtils } from "cw-utils";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable()
export class SpecialityListProvider implements Resolve<any> {
    speciality: Speciality[];
    specialityEdit: Speciality;
    onDataChanged: BehaviorSubject<any>;
    routeParams: any;
    state: any;
    pageOptions: PageOptions;
    currentPage: PageOptions;

    constructor(public gw: ApiGateway, private location: Location) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        // Get state for current or new page
        this.state = this.location.getState();
        if (this.state?.currentPage && state.url.includes(this.state?.path)) {
            this.currentPage = this.state?.currentPage;
        }
        this.specialityEdit = this.state?.currentSpeciality;

        if (this.currentPage) {
            this.pageOptions = this.currentPage;
        } else {
            this.pageOptions = new PageOptions();
            this.pageOptions.fieldSort = "name";
        }
        return new Promise<void>((resolve, reject) => {
            Promise.all([this.getPage(this.pageOptions)]).then(() => {
                resolve();
            }, reject);
        });
    }

    get(id: number): Observable<Speciality> {
        if (!id) {
            return null;
        }
        return this.gw.get("speciality/:id", { id: id });
    }

    get currentSpeciality(): Speciality {
        return this.specialityEdit;
    }

    getSpecialityInternal(pageOptions): Promise<any> {
        let urlPath = "speciality/search/internal";

        return new Promise((resolve, reject) => {
            this.gw.post(urlPath, pageOptions).subscribe({
                next: (res: HttpResponse<any>) => {
                    resolve(res);
                },
                error: (err) => {
                    reject(err);
                },
            });
        });
    }

    getAll(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get("speciality/").subscribe({
                next: (res: HttpResponse<any>) => {
                    this.speciality = res.body;
                    this.onDataChanged.next(this.speciality);
                    resolve(res);
                },
                error: (err) => {
                    reject(err);
                },
            });
        });
    }

    getPage(pageOptions: PageOptions, entity?: String): Promise<any> {
        let urlPath = "speciality/search";
        if (entity) {
            urlPath = entity + urlPath;
        }

        return new Promise((resolve, reject) => {
            this.gw.post(urlPath, pageOptions).subscribe({
                next: (res: HttpResponse<any>) => {
                    if (
                        !CwUtils.compare(this.speciality, res.body.content) &&
                        res.body.content.length > 0
                    ) {
                        this.speciality = res.body.content;
                        this.onDataChanged.next(this.speciality);
                    } else {
                        this.speciality = res.body.content;
                    }
                    resolve(res);
                },
                error: (err) => {
                    reject(err);
                },
            });
        });
    }
    getPageSimple(pageOptions: PageOptions): Promise<any> {
        let urlPath = "speciality/search/simple";

        return new Promise((resolve, reject) => {
            this.gw.post(urlPath, pageOptions).subscribe({
                next: (res: HttpResponse<any>) => {
                    resolve(res);
                },
                error: (err) => {
                    reject(err);
                },
            });
        });
    }

    getSpecialityByPerformer(
        pageOptions: PageOptions,
        professionalId
    ): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .post(
                    "scheduling/speciality/search/:professionalId",
                    { professionalId: professionalId },
                    pageOptions
                )
                .subscribe({
                    next: (res: HttpResponse<any>) => {
                        resolve(res);
                    },
                    error: (err) => {
                        reject(err);
                    },
                });
        });
    }

    getPageSettings() {
        if (this.currentPage) {
            return this.pageOptions;
        } else {
            return;
        }
    }
}
